import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const TITLES: Record<string, string> = {
  '/app': 'Dashboard',
  '/app/studio': 'Studio',
  '/app/library': 'Library',
  '/app/wave': 'The Wave',
  '/app/wave-radio': 'Wave Radio',
  '/app/arena': 'The Arena',
  '/app/collabs': 'Collabs',
  '/app/messages': 'Messages',
  '/app/live': 'Live Battle',
  '/app/tiers': 'Contracts',
  '/app/safety': 'Safety & Rules',
  '/app/admin': 'Admin / Control Room',
  '/app/notifications': 'Notifications',
  '/app/profile': 'Profile / Settings',
};

export function Header() {
  const { currentUser, unreadCount } = useApp();
  const { pathname } = useLocation();
  const title = TITLES[pathname] ?? 'IAMMUZIK';
  const initials = (currentUser?.username ?? 'U').slice(0, 2).toUpperCase();

  return (
    <header className="topbar">
      <div className="topbar-title">{title}</div>
      <div className="topbar-spacer" />

      <Link to="/app/studio" className="btn btn-gold btn-sm">
        + Upload / Create
      </Link>

      <Link to="/app/notifications" className="icon-btn" aria-label="Notifications">
        🔔
        {unreadCount > 0 && (
          <span className="badge-count">{unreadCount}</span>
        )}
      </Link>

      <Link to="/app/profile" className="avatar" style={{ background: currentUser?.avatarColor }}>
        {initials}
      </Link>
    </header>
  );
}
